import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
  FormControl,
  FormHelperText,
  Grid,
  Input,
  InputLabel,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { useLicenciasConducir } from "../hooks/useLicenciasConducir";
import GifLoader from "../components/ui/gifLoader";
import Sello from "../assets/img/Sello.png";

const PDFViewer = ({ base64PDF }) => {
  return (
    <Paper elevation={3} sx={{ p: 2, width: "100%" }}>
      <Box
        sx={{
          width: "100%",
          height: "600px",
          border: "1px solid #ddd",
          borderRadius: 1,
        }}
      >
        <iframe
          src={base64PDF}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
          title="PDF Viewer"
        />
      </Box>
    </Paper>
  );
};

const FormContainer = ({
  state,
  validate,
  handleInputChange,
  handleConsulta,
}) => {
  const { licencia, curp, correo } = state;
  const { ecurp, ecorreo } = validate;
  return (
    <Stack
      component="form"
      sx={{ width: "25ch", marginTop: 2 }}
      spacing={3}
      noValidate
      autoComplete="off"
    >
      <FormControl required>
        <InputLabel htmlFor="my-input">No. de licencia</InputLabel>
        <Input
          id="my-input"
          aria-describedby="my-helper-text"
          name="licencia"
          value={licencia}
          onChange={(e) => {
            e.target.value = e.target.value
              .toUpperCase()
              .replace(/[^A-Z0-9]/g, "");
            handleInputChange(e);
          }}
          inputProps={{ maxLength: 25 }}
        />
        <FormHelperText id="my-helper-text">
          Ingresa tu número de licencia.
        </FormHelperText>
      </FormControl>
      <FormControl error={curp !== "" && ecurp} required>
        <InputLabel htmlFor="my-input">CURP</InputLabel>
        <Input
          id="my-input"
          aria-describedby="my-helper-text"
          name="curp"
          value={curp}
          onChange={(e) => {
            e.target.value = e.target.value
              .toUpperCase()
              .replace(/[^A-Z0-9]/g, "");
            handleInputChange(e);
          }}
          inputProps={{ maxLength: 18 }}
        />
        <FormHelperText id="my-helper-text">Ingresa tu CURP.</FormHelperText>
      </FormControl>
      <FormControl error={correo !== "" && ecorreo} required>
        <InputLabel htmlFor="my-input">Correo</InputLabel>
        <Input
          id="my-input"
          aria-describedby="my-helper-text"
          name="correo"
          value={correo}
          onChange={handleInputChange}
        />
        <FormHelperText id="my-helper-text">
          Ingresa tu correo electrónico.
        </FormHelperText>
      </FormControl>
      <FormControl sx={{ alignItems: "center" }}>
        <div
          style={{
            width: "50%",
          }}
          className="cta cta--guinda"
          onClick={handleConsulta}
        >
          Consultar
        </div>
      </FormControl>
    </Stack>
  );
};

const CardContainer = ({ state, handleClear, handleActionButton }) => {
  const { licencia, curp, correo, alertMess, status, lineaCaptura, nombre } =
    state;
  return (
    <Grid container spacing={2} sx={{ marginTop: 3 }}>
      <Grid item xs={4}>
        <Card elevation={3} sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
          <CardContent sx={{ textAlign: "left" }}>
            <Typography
              gutterBottom
              sx={{ color: "text.secondary", fontSize: 14 }}
            >
              No. Licencia:
              <br />
              <span
                style={{ color: "black", fontWeight: "bold", fontSize: 13 }}
              >
                {licencia}
              </span>
            </Typography>
            <Typography
              gutterBottom
              sx={{ color: "text.secondary", fontSize: 14 }}
            >
              CURP:
              <br />
              <span
                style={{ color: "black", fontWeight: "bold", fontSize: 13 }}
              >
                {curp}
              </span>
            </Typography>
            <Typography
              gutterBottom
              sx={{ color: "text.secondary", fontSize: 14 }}
            >
              Correo:
              <br />
              <span
                style={{ color: "black", fontWeight: "bold", fontSize: 13 }}
              >
                {correo}
              </span>
            </Typography>
            {nombre && (
              <Typography
                gutterBottom
                sx={{ color: "text.secondary", fontSize: 14 }}
              >
                Nombre:
                <br />
                <span
                  style={{ color: "black", fontWeight: "bold", fontSize: 13 }}
                >
                  {nombre}
                </span>
              </Typography>
            )}
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={8}>
        <Card elevation={3} sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
          <CardContent sx={{ justifyItems: "center", flex: 2 }}>
            <Alert
              severity="success"
              sx={{
                padding: 2,
                marginTop: 1,
                justifyContent: "center",
                width: "90%",
                textAlign: "center",
                alignItems: "center",
                "& .MuiAlert-icon": {
                  padding: 0,
                  fontSize: 75,
                  marginRight: 4,
                },
                boxShadow: "3px 3px 3px 0px var(--black-alpha-20)",
              }}
            >
              <AlertTitle sx={{ fontSize: 18 }}>{alertMess}</AlertTitle>
              {lineaCaptura && (
                <AlertTitle sx={{ fontSize: 18, textAlign: "left" }}>
                  Linea captura: {lineaCaptura}
                </AlertTitle>
              )}
              <Button
                variant="contained"
                sx={{
                  marginTop: 2,
                  backgroundColor: "var(--main-color-vino)",
                  "&:hover": {
                    backgroundColor: "var(--main-color-vino)",
                    transform: "scale(1.005)",
                    boxShadow: "3px 3px 6px 0px var(--black-alpha-20)",
                  },
                }}
                onClick={handleActionButton}
              >
                {status === 0
                  ? "Generar linea de captura"
                  : status === 1
                    ? "Pagar"
                    : "Descargar"}
              </Button>
            </Alert>
          </CardContent>
          <CardActions sx={{ justifyContent: "end", padding: 2 }}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "var(--main-color-vino)",
                "&:hover": {
                  backgroundColor: "var(--main-color-vino)",
                  transform: "scale(1.005)",
                  boxShadow: "3px 3px 6px 0px var(--black-alpha-20)",
                },
              }}
              onClick={handleClear}
            >
              Volver a consultar
            </Button>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  );
};

export const LicenciasConducirView = () => {
  const {
    state,
    validate,
    loader,
    handleInputChange,
    handleConsulta,
    handleClear,
    handleActionButton,
  } = useLicenciasConducir();

  const { showCard, pdfBase64 } = state;
  const pdfSrc = `data:application/pdf;base64,${pdfBase64}`;
  return (
    <>
      {loader && <GifLoader />}
      <Container maxWidth="lg">
        <Box
          sx={{
            bgcolor: "#fdfeffff",
            borderRadius: 2,
            boxShadow: 2,
            padding: 5,
            justifyItems: "center",
          }}
        >
          <Grid container sx={{ justifyContent: "center" }}>
            <div
              style={{
                width: "10vw",
                height: "20vh",
              }}
            >
              <img
                className="logo-header-ventanilla HeaderResponsivelogoGD"
                src={Sello}
                alt="Ventanilla Digital de Trámites"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
            <div style={{ alignContent: "center", marginLeft: 10 }}>
              <h3
                style={{
                  color: "#6f1d46",
                  fontSize: "32px",
                  fontWeight: "bold",
                }}
              >
                Solicitud Constancia de Registro y Vigencia de Licencia
              </h3>
            </div>
          </Grid>
          {!showCard ? (
            <FormContainer
              state={state}
              validate={validate}
              handleInputChange={handleInputChange}
              handleConsulta={handleConsulta}
            />
          ) : (
            <CardContainer
              state={state}
              handleClear={handleClear}
              handleActionButton={handleActionButton}
            />
          )}

          {pdfBase64 && (
            <Box sx={{ marginTop: 3, width: "100%" }}>
              <PDFViewer base64PDF={pdfSrc} />
            </Box>
          )}
        </Box>
      </Container>
    </>
  );
};
